import { jsx, jsxs } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { forwardRef } from "react";
import { useSlotProps } from "../../base/index.js";
import { useHandleSnackState } from "../SnackMachine/index.js";
import { alertSnackName } from "./classes.js";
import { Content } from "./components/Content.js";
import { Root } from "./components/Root.js";
import { Title } from "./components/Title.js";
import { useUtilityClasses } from "./hooks/useUtilityClasses.js";
function noop() {
}
const AlertSnack = forwardRef(AlertSnackComponent);
function AlertSnackComponent(inProps, ref) {
  const props = useThemeProps({
    name: alertSnackName,
    props: inProps
  });
  const {
    snack,
    variant,
    snackMachine,
    componentsProps,
    testId = "tidal-alertsnack",
    userContent: UserContent,
    ...rest
  } = props;
  const { title, message, severity, autoHideDuration } = snack;
  const { open, onClose, onEntered, onExited } = useHandleSnackState(props);
  const ownerState = {
    ...rest,
    snack,
    variant,
    snackMachine,
    componentsProps
  };
  const utilityClasses = useUtilityClasses(props);
  const rootSlotProps = useSlotProps({
    ownerState,
    elementType: Root,
    externalForwardedProps: rest,
    className: utilityClasses.root,
    externalSlotProps: componentsProps?.root,
    additionalProps: {
      ref,
      open,
      onClose,
      autoHideDuration,
      "data-tidal": "AlertSnack",
      "data-testid": testId,
      TransitionProps: { onEntered, onExited },
      ClickAwayListenerProps: { onClickAway: noop }
    }
  });
  const contentSlotProps = useSlotProps({
    ownerState,
    elementType: Content,
    className: utilityClasses.content,
    externalSlotProps: componentsProps?.content,
    additionalProps: {
      variant,
      onClose,
      severity
    }
  });
  const titleSlotProps = useSlotProps({
    ownerState,
    elementType: Title,
    className: utilityClasses.title,
    externalSlotProps: componentsProps?.title
  });
  const content = UserContent ? /* @__PURE__ */ jsx(UserContent, { ...props }) : typeof message === "string" ? message : null;
  return /* @__PURE__ */ jsx(Root, { ...rootSlotProps, children: /* @__PURE__ */ jsxs(Content, { ...contentSlotProps, children: [
    title && /* @__PURE__ */ jsx(Title, { ...titleSlotProps, children: title }),
    content
  ] }) });
}
export {
  AlertSnack
};
//# sourceMappingURL=AlertSnack.js.map
